export default __webpack_public_path__ + "static/media/download (2).f4a7014d.svg";